import { useEffect, useState } from 'react';

type WindowSize = {
  width: number;
  height: number;
};

export const useWindowSize = (): WindowSize => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: 0,
    height: 0,
  });
  const isBrowser = typeof window !== 'undefined';

  useEffect(() => {
    const handleResize = (): void => {
      setWindowSize({
        width: window?.innerWidth,
        height: window?.innerHeight,
      });
    };

    if (isBrowser) {
      handleResize();

      window?.addEventListener('resize', handleResize);

      return (): void => {
        window?.removeEventListener('resize', handleResize);
      };
    }
  }, [isBrowser]);

  return windowSize;
};
